/**
* @description: 我的寄件地址
* @author: 51fan
*/
<template>
  <div class="addressManageContent main-wrap">
    <div class="main-top">
      <el-button type="primary" class="addAddress h40" @click="rowAdd" icon="iconfont iconxinzeng">{{ $lang('新增寄件地址') }}</el-button>
      <div class="searchParam">
        <div class="searchParamInput">
          <el-input v-model="searchParam" :placeholder="$lang('姓名/联系电话/地址')" style="width:336px !important"></el-input>
        </div>
        <el-button type="primary" @click="searchChange" icon="iconfont iconchaxun" class="h32 search">{{ $lang("查询") }}</el-button>
        <el-button type="primary" @click="resetSearch" plain icon="iconfont iconshanchu" class="h32">{{ $lang("清空") }}</el-button>
        <!--<el-button type="primary" class="addAddress" @click="rowAdd"><i class="iconfont iconxinzeng"></i> 新增寄件地址</el-button> -->
      </div>
    </div>
    <div class="main-table">
      <JmsTableScroll
        ref="params"
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @row-edit="rowEdit"
        @row-del="rowDel"
        @size-change="sizeChange"
        @select-change="selectionChange"
        @current-change="currentChange">
        <template slot="isDefault" slot-scope="data">
          <el-switch
            v-model="data.row.isDefault"
            active-color="#13ce66"
            inactive-color="#dcdfe6"
            :active-value="1"
            :inactive-value="2"
            disabled>
          </el-switch>
        </template>
      </JmsTableScroll>
    </div>
    <!-- 编辑地址 -->
    <el-dialog :title="diglogTitle" v-if="editDialogVisible" :visible.sync="editDialogVisible" width="1020px" @close="handleClose" :modal-append-to-body="false"
               :close-on-click-modal="false">
      <el-form class="el-form-edit" ref="tableForm" :rules="rules" :inline="true" :model="rowData" label-position="left" label-suffix=" :">
        <!-- <el-form-item label="地址识别" class="item-col-4">
          <el-input v-model="analysisAddress" :autosize="{minRows: 5 }"  type="textarea" placeholder="粘贴或者输入整段地址，点击“识别”自动拆分姓名、电话和地址。例如：李小兔，13800138000，上海市黄浦区某某大厦…">
          </el-input>
          <div class="oper">
            <span class="red" @click="discern(0)">智能识别</span>
            <span @click="discern(1)">清空</span>
          </div>
        </el-form-item> -->
        <el-form-item :label="$lang('寄件人姓名')" prop="name" class="myDetailItem">
          <el-input v-model="rowData.name" :minlength="1" :maxlength="50" :placeholder="$lang('请输入寄件人姓名')"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('寄件人电话')" prop="mobile" class="myDetailItem">
          <!--<el-input v-model="rowData.mobile" :maxlength='11' :placeholder="$lang('请输入寄件人电话')"></el-input>-->
          <base-phone-input v-model="rowData.mobile" :maxlength="11" :placeholder="$lang('请输入寄件人电话')"/>
        </el-form-item>
        <el-form-item :label="$lang('寄件人电话') + '2'" prop="alternateMobile" class="myDetailItem">
          <!--<el-input v-model="rowData.alternateMobile" :maxlength='11' :placeholder="$lang('请输入寄件人电话')"></el-input>-->
          <base-phone-input v-model="rowData.alternateMobile" :maxlength="11" :placeholder="$lang('请输入寄件人电话')"/>
        </el-form-item>
        <!-- <el-form-item :label="$lang('收件省')" prop="companyName" class="myDetailItem">
          <el-input v-model="rowData.companyName" :placeholder="$lang('请输入公司')"></el-input>
        </el-form-item> -->
        <!-- <el-form-item :label="$lang('省/市/区')" prop="province" class="myDetailItem">
          <BaseAddress ref="provinceSearch" :initAddressData="initAddressData" :showLevel="3" v-model="rowData.province"> </BaseAddress>
        </el-form-item> -->
        <!-- <el-form-item :label="$lang('收件城市')" prop="postalCode" class="myDetailItem">
            <template slot="label"><span :title="$lang('邮编')">{{$lang('邮编')}}</span></template>
            <el-input v-model="rowData.postalCode" :placeholder="$lang('请输入邮编')" :minlength="1" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('邮箱')" prop="email" class="myDetailItem">
            <template slot="label"><span :title="$lang('邮箱')">{{$lang('邮箱')}}</span></template>
            <el-input v-model="rowData.email" :minlength="1" :placeholder="$lang('请输入邮箱')"  :maxlength="30"></el-input>
        </el-form-item> -->
        <el-form-item :label="$lang('寄件省')" prop="provinceName" class="myDetailItem">
          <el-select v-model="rowData.provinceName" filterable @change="dataProvinceChange($event)">
            <el-option
              v-for="item in provinceArray"
              :key="item.id"
              :label="(item.nativeName +'（'+ item.enName + '）')"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$lang('寄件城市')" prop="cityName" class="myDetailItem">
          <el-select v-model="rowData.cityName" filterable @change="dataCityChange($event)">
            <el-option
              v-for="item in cityList"
              :key="item.id"
              :label="(item.nativeName +'（'+ item.enName + '）')"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$lang('寄件地区')" prop="areaName" class="myDetailItem">
          <!-- <el-select v-model="rowData.areaName" @change="dataAreaChange($event)">
            <el-option
              v-for="item in areaList"
              :key="item.id"
              :label="item.nativeName"
              :value="item.id"
            />
          </el-select> -->
          <el-autocomplete
            class="inline-input"
            popper-class="my-kqoption"
            :popper-append-to-body="false"
            v-model="rowData.areaName"
            :fetch-suggestions="querySearch"
            :placeholder="$lang('请输入内容')"
            value-key="enName"
            @blur="blurCity($event, 1)"
            @select="dataAreaChange($event,1)">
          </el-autocomplete>
        </el-form-item>
        <el-form-item :label="$lang('寄件街道')" prop="street" class="myDetailItem">
          <el-input v-model="rowData.street" :placeholder="$lang('请输入')" :minlength="1" :maxlength="20"/>
        </el-form-item>
        <!-- <el-form-item :label="$lang('寄件楼号')" prop="buildingNo" class="myDetailItem">
          <el-input v-model="rowData.buildingNo" :placeholder="$lang('请输入')" :minlength="1" :maxlength="5"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('寄件楼层')" prop="buildingFloor" class="myDetailItem">
          <el-input v-model="rowData.buildingFloor" :placeholder="$lang('请输入')" :minlength="1" :maxlength="5"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('寄件房号')" prop="roomNumber" class="myDetailItem">
          <el-input v-model="rowData.roomNumber" :placeholder="$lang('请输入')" :minlength="1" :maxlength="5"></el-input>
        </el-form-item> -->
        <!-- <div>
          <el-form-item :label="$lang('详细地址')" prop="detailedAddress" class="addressDeatil">
            <el-input v-model="rowData.detailedAddress" :placeholder="$lang('请输入寄件人所在街道以及详细地址')"  :minlength="1"  :maxlength="80"></el-input>
          </el-form-item>
        </div> -->
        <el-form-item :label="$lang('设为默认')" prop="isDefault">
          <el-switch v-model="rowData.isDefault" active-color="#13ce66" inactive-color="#ddd"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="handleClose('tableForm')">取 消</el-button> -->
        <el-button type="primary" :loading="keyBtn" @click="handleSubmit('tableForm')" class="h40 h104">{{ $lang('保存') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants'
// import JmsTableScroll from '@/components/jms-widget/jms-table'
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin'
import { addAddress, reqAddressList, updateAddress, delAddress } from '@api/module/customer'
import { RULES, phoneAndMobile, checkAddressFormat } from '@utils/rules'
import * as Api from '@api/base/public'
import cloneDeep from 'lodash/cloneDeep'
import BasePhoneInput from '@/components/base/BasePhoneInput'

export default {
  name: 'MailingAddress',
  components: {
    BasePhoneInput,
    JmsTableScroll,
  },
  mixins: [mixin],
  data() {
    return {
      COM_HTTP: {
        reqList: reqAddressList,
        reqAdd: addAddress,
        reqUpdate: updateAddress,
        reqDel: delAddress,
      },
      diglogTitle: this.$lang('新增寄件地址'),
      analysisAddress: '',
      searchParam: '',
      rowData: {
        name: '',
        mobile: '',
        alternateMobile: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        detailedAddress: '',
        street: '',
        buildingNo: '',
        buildingFloor: '',
        roomNumber: '',
        isDefault: false, // 是否设置为默认地址 1设置默认地址 2 不设置
        type: 1, // 1 寄件 2收件
        id: '',
        postalCode: '',
        email: '',
      },
      provinceArray: [], // 省
      cityList: [], // 城市
      areaList: [], // 地区
      initAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
        },
        defaultData: {},
      },
      tableList: [],
      isRowDetailUrl: false,
      rules: {
        name: [RULES.requiredTrim],
        mobile: [RULES.requiredTrim, { validator: phoneAndMobile }],
        alternateMobile: [{ validator: phoneAndMobile }],
        province: [RULES.requiredSelect],
        detailedAddress: [RULES.requiredTrim, { validator: checkAddressFormat }],
        provinceName: [RULES.requiredSelect],
        cityName: [RULES.requiredSelect],
        areaName: [RULES.requiredSelect],
        street: [RULES.requiredTrim],
        // buildingNo: [RULES.requiredTrim],

      },
      delTitObj: {
        title: this.$lang('删除寄件地址'),
        subTitle: this.$lang('你确定要删除该寄件地址吗？'),
        threeTitle: '',
      },
    }
  },
  computed: {
    listOpt() {
      return {
        fixHeight: 90,
        border: true,
        selection: false,
        menu: true,
        menuWidth: 150,
        rowKey: '$index',
        viewBtn: false,
        column: [
          {
            label: '寄件人姓名',
            prop: 'name',
          },
          // {
          //   label: '电话区号',
          //   prop: 'areaCode',
          //   formatter: (row, value, label, column) => {
          //     return '971'
          //   },
          // },
          {
            label: '寄件人电话', //  扫描员
            prop: 'mobile',
          },
          {
            label: '寄件人电话2',
            prop: 'alternateMobile',
          },
          // {
          //   label: '寄件房号',
          //   prop: 'roomNumber',
          // },
          // {
          //   label: '寄件楼层',
          //   prop: 'buildingFloor',
          // },
          // {
          //   label: '寄件楼号',
          //   prop: 'buildingNo',
          // },
          // {
          //   label: '寄件街道',
          //   prop: 'street',
          // },
          {
            label: '寄件地区',
            prop: 'areaName',
          },
          {
            label: '寄件城市',
            prop: 'cityName',
          },
          {
            label: '寄件省',
            prop: 'provinceName',
          },
          // {
          //   label: '寄件详细地址',
          //   prop: 'detailedAddress',
          // },
          {
            label: '是否默认',
            prop: 'isDefault',
            slot: true,
            // formatter: (row, value, label, column) => {
            //   const map = {
            //     1: '<i class="dot green" style="color: #00da00;"></i> ' + '是',
            //     2: '<i class="dot oragin" style="color: #ffa111"></i> ' + '否',
            //   }
            //   return map[row.isDefault]
            // },
          },
        ],
      }
    },
  },
  created() {
    this.getProList()
  },
  activated() {
    console.log('activated')
    this.$nextTick(() => {
      if (this.$refs['params']) {
        this.$refs['params'].$refs['table'].doLayout()
      }
    })
  },
  beforeUpdate() {
    console.log('beforeUpdate')
  },
  methods: {
    /**
     * 修复表格
     */
    fixTableLayoutError() {
      this.$nextTick(() => {
        if (this.$refs['params']) {
          this.$refs['params'].$refs['table'].doLayout()
        }
      })
    },
    filterPhone(val) {
      if (!val) return ''
      if (val.indexOf('+') !== -1) {
        return val
      } else {
        return '+20-' + val
      }
    },
    /**
     * 接口调用成功回调
     */
    searchAfterFun() {
      this.$nextTick(() => {
        if (this.$refs['params']) {
          this.$refs['params'].$refs['table'].doLayout()
        }
      })
    },
    // 编辑
    rowEdit(row) {
      this.fromType = 'editRouter'
      this.editDialogVisible = true
      const obj = {
        name: row.name,
        mobile: this.filterPhone(row.mobile),
        alternateMobile: this.filterPhone(row.alternateMobile),
        provinceId: row.provinceId,
        provinceName: row.provinceName,
        cityId: row.cityId,
        cityName: row.cityName,
        areaId: row.areaId,
        areaCode: row.areaCode,
        areaName: row.areaName,
        detailedAddress: row.detailedAddress,
        street: row.street,
        buildingNo: row.buildingNo,
        buildingFloor: row.buildingFloor,
        roomNumber: row.roomNumber,
        isDefault: row.isDefault === 1, // 是否设置为默认地址 1设置默认地址 2 不设置
        id: row.id,
        email: row.email,
      }
      this.rowData = Object.assign(this.rowData, obj)
    },
    // discern(type) {
    //   let text
    //   switch (type) {
    //     case 0:
    //       console.log(1, { ...this.rowData })
    //       if (!this.analysisAddress) { return }
    //       text = this.analysisAddress
    //       text = text.replace(/\s/g, '')
    //       queryAddressAnalysisAddress({ text }).then(res => {
    //         const { code, msg, data } = res
    //         if (code === RESPONSE_SUCCESS) {
    //           if (data) {
    //             const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
    //             const obj = {
    //               name: person,
    //               mobile: phonenum,
    //               detailedAddress: detail,
    //               provinceName: province,
    //               provinceId: provinceCode,
    //               cityId: cityCode,
    //               cityName: city,
    //               areaId: countyCode,
    //               areaName: county,
    //               province: {
    //                 provinceName: province,
    //                 provinceId: provinceCode,
    //                 cityId: cityCode,
    //                 cityName: city,
    //                 areaId: countyCode,
    //                 areaName: county,
    //               },
    //             }
    //             this.rowData = Object.assign(this.rowData, obj)
    //             console.log(2, { ...this.rowData })
    //           }
    //         } else {
    //           this.$message.error(msg)
    //         }
    //       })
    //       break
    //     case 1:
    //       this.analysisAddress = ''
    //       break
    //     default:
    //       break
    //   }
    // },
    getParams() {
      return {
        type: 1,
        keyword: this.searchParam,
      }
    },
    // 获取酋长国数据
    async getProList() {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        this.provinceArray = data
      } else {
        this.$message.error(msg)
      }
    },

    // 选中获取值
    dataProvinceChange(value) {
      this.getCityList(value)
    },
    blurCity(val, type) {
      console.log(val.target.value, type)
      const hasCity = this.areaList.find(item => item.nativeName === val.target.value)
      hasCity ? this.rowData.areaId = hasCity.id : this.rowData.areaId = ''
      console.log('1----------------', val.target.value, hasCity)
    },
    querySearch(queryString, cb) {
      // var restaurants = this.areaList
      var restaurants = cloneDeep(this.areaList)
      console.log(queryString)
      console.log(restaurants)
      var results = queryString ? restaurants.filter(this.createFilter2(queryString)) : restaurants
      var listPam = []
      if (results.length > 0) {
        results.forEach((item) => {
          listPam.push(Object.assign(item, { enName: (item.nativeName + '（' + item.enName + '）') }))
        })
      }
      console.log('llllllll', results)
      // 调用 callback 返回建议列表的数据
      cb(listPam)
    },
    createFilter2(queryString) {
      return (restaurant) => {
        var restaurantVal = restaurant.nativeName + '（' + restaurant.enName + '）'
        return (restaurantVal.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    // 获取城市数据
    async getCityList(parentId) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        this.cityList = data
        this.rowData.provinceId = parentId
        // this.rowData.cityId = data[0].id
        // this.rowData.cityName = data[0].nativeName + '（' + data[0].enName + '）'
        // this.getAreaList(data[0].id)
        this.rowData.cityId = ''
        this.rowData.cityName = ''
        this.rowData.areaId = ''
        this.rowData.areaName = ''
        let obj = {}
        obj = this.provinceArray.find((item) => {
          return item.id === parentId
        })
        this.rowData.provinceName = obj.nativeName + '（' + obj.enName + '）'
      } else {
        this.$message.error(msg)
      }
    },

    // 获取区域数据
    async getAreaList(parentId) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 4, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        this.areaList = data
        this.rowData.cityId = parentId
        // this.rowData.areaId = data[0].id
        // this.rowData.areaName = data[0].nativeName + '（' + data[0].enName + '）'
        this.rowData.areaId = ''
        this.rowData.areaName = ''
        let obj = {}
        obj = this.cityList.find((item) => {
          return item.id === parentId
        })
        this.rowData.cityName = obj.nativeName + '（' + obj.enName + '）'
      } else {
        this.$message.error(msg)
      }
    },

    // 选中城市
    dataCityChange(value) {
      // console.log(value)
      this.rowData.cityId = value
      const obj = this.cityList.find((item) => {
        return item.id === value
      })
      this.rowData.cityName = obj.nativeName + '（' + obj.enName + '）'
      this.getAreaList(value)
    },

    dataAreaChange(value) {
      this.rowData.areaId = value.id
      const obj = this.areaList.find((item) => {
        return item.id === value.id
      })
      this.rowData.areaName = obj.nativeName + '（' + obj.enName + '）'
    },

    // 表单保存前
    beforeSubmit() {
      // debugger
      const isDefault = this.rowData.isDefault ? 1 : 2
      // const params = {
      //   name: this.rowData.name.trim(),
      // }
      return { ...this.rowData, isDefault }
    },
    // 弹窗关闭前
    beforehandleClose() {
      this.diglogTitle = this.$lang('新增寄件地址')
      this.cityList = []
    },
    // 重新处理字段不一的查看字段
    handleData(row) {
      // debugger
      this.diglogTitle = this.$lang('编辑地址')
      this.getCityInfo(row.provinceId)
      this.getAreaInfo(row.cityId)
      // const { provinceId, provinceName, cityId, cityName, areaId, areaName, isDefault } = row
      // provinceName: '',
      //   cityName: '',
      //   areaName: '',
      // this.initAddressData.defaultData.provinceId = ''
      // this.initAddressData.defaultData.provinceName = ''
      // this.initAddressData.defaultData.cityId = ''
      // this.initAddressData.defaultData.cityName = ''
      // this.initAddressData.defaultData.areaId = ''
      // this.initAddressData.defaultData.areaName = ''

      // const defaultData = { provinceId, provinceName, cityId, cityName, areaId, areaName }
      // this.$nextTick(function () {
      //   this.$set(this.initAddressData, 'defaultData', defaultData)
      // })
      return { ...row, isDefault: row.isDefault === 1, type: 1 }
    },

    // 查询城市数据
    async getCityInfo(provinceId) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        this.cityList = data
      } else {
        this.$message.error(msg)
      }
    },
    // 查询地区数据
    async getAreaInfo(provinceId) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 4, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        this.areaList = data
      } else {
        this.$message.error(msg)
      }
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = ''
    },
    // 重置表单项
    clearFormItem() {
      this.rowData.name = ''
      this.rowData.mobile = ''
      this.rowData.alternateMobile = ''
      this.rowData.provinceId = ''
      this.rowData.provinceName = ''
      this.rowData.cityId = ''
      this.rowData.cityName = ''
      this.rowData.areaId = ''
      this.rowData.areaName = ''
      this.rowData.detailedAddress = ''
      this.rowData.street = ''
      this.rowData.buildingNo = ''
      this.rowData.buildingFloor = ''
      this.rowData.roomNumber = ''
      this.rowData.isDefault = false // 是否设置为默认地址 1设置默认地址 2 不设置
      this.rowData.type = 1 // 1 寄件 2收件
      this.rowData.id = ''
      this.rowData.postalCode = ''
      this.rowData.email = ''

      // this.initAddressData.defaultData.provinceId = ''
      // this.initAddressData.defaultData.provinceName = ''
      // this.initAddressData.defaultData.cityId = ''
      // this.initAddressData.defaultData.cityName = ''
      // this.initAddressData.defaultData.areaId = ''
      // this.initAddressData.defaultData.areaName = ''
      // this.$refs.provinceSearch.clearInput()
      // this.$refs['tableForm'].resetFields()
      // this.$refs['tableForm'].clearValidate()
    },
  },
}
</script>

<style lang="scss" scoped>
body {
  ::v-deep .my-kqoption {
    width: 800px !important;
  }
}

.el-autocomplete {
  ::v-deep .my-kqoption {
    width: auto !important;
  }
}

.addressManageContent {
  .main-top {
    padding: 16px 24px;
  }

  .main-table {
    padding: 12px 24px;
    background: #edeef3;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .searchParam {
    display: inline-flex;
    width: 100%;
    position: relative;
    margin-top: 10px;

    .searchParamInput {
      padding-right: 16px;
    }

    .el-button {
      height: 32px;
    }

    .addAddress {
      position: absolute;
      right: 0;
      height: 32px;
    }
  }

  .dot.oragin::before {
    width: 8px;
    height: 8px;
    background: #e60012;
  }

  /*.dot.green::before {*/
  /*  background: #52C41A;*/
  /*}*/
  .el-dialog {
    .el-dialog__body {
      .myDetail {
        display: inline-flex;
        padding: 0 0 24px 0;

        .myDetailItem {
          width: 200px;
          padding: 0 8px;

          .myDetailItemText {
            padding-bottom: 4px;
          }
        }
      }

      .addressDeatil {
        .el-input {
          width: 360px !important;
        }
      }
    }

    .reuqire {
      color: red;
    }

    .el-dialog__header {
      padding: 12px 25px !important;
      border-bottom: 1px solid #eeeeee;
    }
  }
}

.oper {
  position: absolute;
  right: 20px;
  bottom: 5px;
  cursor: pointer;
  color: #333;

  .red {
    color: red;
    margin-right: 20px;
  }
}
</style>
<style lang="scss">
.addressManageContent {
  .el-table__fixed, .el-table__fixed-right {
    height: 705px !important;
  }
}
</style>
